import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import { COURSE_GUIDE_LABEL } from 'chameleon-src/components/SidebarWrapperTwoLevels/constants';

const Breadcrumbs = ({ subjectId, unitNumber }) => (
  <div className="flex items-center">
    <Link
      to={`/${subjectId}/home?unit=${unitNumber}`}
      className="text-blue-700 hover:text-blue-600 font-medium text-base"
      onlyActiveOnIndex={false}
    >
      {COURSE_GUIDE_LABEL}
    </Link>
    <span className="ml-0.8">
      <Icon id="chevron_right" className="ml-0.8 h-4 self-center" />
    </span>
    <span className="ml-0.8 text-gray-800 font-medium text-base">
      {COURSE_GUIDE_LABEL} Search
    </span>
  </div>
);

Breadcrumbs.propTypes = {
  unitNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  subjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default Breadcrumbs;
